import createStore from "redux-zero";
import actions from "./actions";

const {items, item_count} = theme.cartState;
const initialState = {
  cart: theme.cartState,
  items, item_count,
  justAdded: {},
  popupActive: false
};
export const store = createStore(initialState);

window.CartStore = store;
CartStore.actions = actions(CartStore);

const searchState = {
  all_empty: false,
  collections: [],
  products: [],
  query: '',
  suggestionQuery: '',
  suggestions: [],
  total_product: 0,
  isFetching: true,
  isSuggestionFetching: true,
}

export const searchStore = createStore(searchState)
